import { Swiper, SwiperSlide } from "swiper/react";
import { useState, useEffect } from "react";
import axios from "axios";
import "../css/swiper.css"
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from 'swiper/modules';

function BannerSwiper() {
  const [banners, setBanners] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 426);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          "https://jiujitsu-json-data.s3.ap-northeast-2.amazonaws.com/jiujitsu/banner_data.json"
        );
        setBanners(response.data);
      } catch (error) {
        console.error("배너 데이터를 불러오는데 실패했습니다:", error);
      }
    };

    fetchBanners();

    // 화면 크기 변경 감지
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 426);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBannerClick = (link) => {
    if (link) {
      window.location.href = link;
    }
  };

  return (
    <Swiper
      modules={[Autoplay,Pagination]}
      pagination={{ clickable: true }}
      className="mySwiper"
      loop={true}
      style={{ height: "400px" }}
      autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
    >
      {banners.map((banner, index) => (
        <SwiperSlide 
          key={index}
          style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            cursor: banner.link ? "pointer" : "default",
            overflow:"hidden",
          }}
          onClick={() => handleBannerClick(banner.link)}
        >
          <img
            src={isMobile ? banner.mobileBannerUrl : banner.pcBannerUrl}
            alt={`Banner ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default BannerSwiper;